import "./styles/global.css";
import App from "./App.svelte";
import { mount } from "svelte";
import { initI18n } from "./lib/i18n";

/* A tab opened before a deploy still asks for the old, hashed page chunks, and
   those are gone: the import 404s and the route renders nothing — not even the
   sidebar (Мои партнёры and Поиск партнёров on 2026-09-22). Reload once to pick
   up the new index.html. The timestamp keeps a chunk that is genuinely missing
   from reloading the page in a loop; then the error surfaces as before. */
const RELOAD_KEY = "oe:chunk-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
  } catch {
    return;
  }
  if (Date.now() - last < 30_000) return;
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const target = document.getElementById("app");
if (!target) throw new Error("#app target not found");

initI18n().finally(() => {
  mount(App, { target });
});
